 /* eslint-disable */
 import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

 export default {
    GetProductCategoties,
    GetProductCategoryDetailsByProductCategoryID,
    SaveProductCategory,
    UpdateProductCategory
 };
 
 async function GetProductCategoties() {  
     const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
     return response.data;
 }

 async function GetProductCategoryDetailsByProductCategoryID(ProductCategoryID) {  
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetailsByProductCategoryID', 'productCategoryID='+ProductCategoryID);
    return response.data;
}

async function SaveProductCategory(values) {

    var formdata={
        ProductCategoryName:values.productCategoryName,
        Decription:values.decription,
        CategoryCode:values.categoryCode,
        IsActive:values.isActive,
        CreatedBy:1,
        CreatedDate:new Date(),
    }

    const response = await CommonPost('/api/ProductCategory/SaveProductCatogery', null, formdata);
    return response;

}

async function UpdateProductCategory(values,productCategoryID) {

    var formdata={
        ProductCategoryID:parseInt(productCategoryID),
        ProductCategoryName:values.productCategoryName,
        Decription:values.decription,
        CategoryCode:values.categoryCode,
        IsActive:values.isActive,
        ModifiedBy:1,
        ModifiedDate:new Date(), 
    }

    const response = await CommonPost('/api/ProductCategory/UpdateProductCatogery', null, formdata);
    return response;

}